/* Account - auth, profile, orders, wishlist, addresses */
(() => {
  const USERS_KEY = "mana_users";
  const SESSION_KEY = "mana_session";

  const authEl = document.querySelector("[data-account-auth]");
  const dashEl = document.querySelector("[data-account-dash]");
  const toastEl = document.querySelector("[data-account-toast]");
  if (!authEl || !dashEl) return;

  const STATUS_LABEL = {
    confirmed: "Confirmed",
    packed: "Packed",
    out_for_delivery: "Out for delivery",
    delivered: "Delivered"
  };

  function uid() {
    return `u_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function normalizePhone(phone) {
    return String(phone || "").replace(/\D/g, "").replace(/^92/, "0");
  }

  function toast(msg) {
    if (!toastEl) return;
    toastEl.hidden = false;
    toastEl.textContent = msg;
    window.clearTimeout(toast._t);
    toast._t = window.setTimeout(() => { toastEl.hidden = true; }, 2600);
  }

  function readUsers() {
    try { return JSON.parse(localStorage.getItem(USERS_KEY) || "[]"); }
    catch (_) { return []; }
  }

  function writeUsers(users) {
    localStorage.setItem(USERS_KEY, JSON.stringify(users));
  }

  function getSession() {
    try { return JSON.parse(localStorage.getItem(SESSION_KEY) || "null"); }
    catch (_) { return null; }
  }

  function setSession(session) {
    if (!session) localStorage.removeItem(SESSION_KEY);
    else localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  }

  function currentUser() {
    const session = getSession();
    if (!session?.id) return null;
    return readUsers().find((u) => u.id === session.id) || null;
  }

  function saveUser(user) {
    const users = readUsers();
    const i = users.findIndex((u) => u.id === user.id);
    if (i >= 0) users[i] = user;
    else users.push(user);
    writeUsers(users);
  }

  function ensureDemoUser() {
    const users = readUsers();
    if (users.some((u) => u.email === "sara@example.com")) return;
    users.push({
      id: "u_demo_sara",
      email: "sara@example.com",
      password: "manna123",
      firstName: "Sara",
      lastName: "Ahmed",
      phone: "03224711112",
      birthday: "",
      gender: "female",
      preferences: { whatsapp: true, email: true, sms: false },
      addresses: [
        {
          id: "a_demo_1",
          label: "Home",
          line1: "House 12, Street 4, DHA Phase 1",
          city: "Lahore",
          area: "Khayaban-e-Jinnah",
          phone: "03224711112",
          postal: "54792",
          isDefault: true
        }
      ],
      linkedOrders: ["MC-10482"],
      createdAt: new Date().toISOString()
    });
    writeUsers(users);
  }

  function wishIds() {
    try { return JSON.parse(localStorage.getItem("mana_wish") || "[]"); }
    catch (_) { return []; }
  }

  function productMap() {
    try { return JSON.parse(localStorage.getItem("mana_products") || "{}"); }
    catch (_) { return {}; }
  }

  function showMsg(el, text, isError) {
    if (!el) return;
    el.hidden = !text;
    el.textContent = text || "";
    el.classList.toggle("is-error", !!isError);
  }

  function setAuthVisible(showAuth) {
    authEl.hidden = !showAuth;
    dashEl.hidden = showAuth;
  }

  function switchPanel(name) {
    document.querySelectorAll("[data-panel]").forEach((btn) => {
      btn.classList.toggle("is-active", btn.getAttribute("data-panel") === name);
    });
    document.querySelectorAll("[data-panel-view]").forEach((panel) => {
      panel.hidden = panel.getAttribute("data-panel-view") !== name;
    });
    const url = new URL(window.location.href);
    url.searchParams.set("tab", name);
    history.replaceState({}, "", url);
  }

  async function fetchOrdersForUser(user) {
    const phone = normalizePhone(user.phone);
    let byPhone = [];
    try {
      const res = await fetch(`/api/orders/by-phone?phone=${encodeURIComponent(phone)}`, { cache: "no-store" });
      const data = await res.json();
      if (res.ok) byPhone = data.orders || [];
    } catch (_) {}

    const linked = [];
    for (const id of user.linkedOrders || []) {
      if (byPhone.some((o) => o.id === id)) continue;
      try {
        const qs = new URLSearchParams({ order: id, phone: user.phone });
        const res = await fetch(`/api/track?${qs}`, { cache: "no-store" });
        if (res.ok) linked.push(await res.json());
      } catch (_) {}
    }
    const map = new Map();
    [...byPhone, ...linked].forEach((o) => map.set(o.id, o));
    return [...map.values()].sort((a, b) => String(b.updatedAt || "").localeCompare(String(a.updatedAt || "")));
  }

  function renderOrderRow(order) {
    const status = STATUS_LABEL[order.status] || order.status;
    const trackUrl = `/track?order=${encodeURIComponent(order.id)}&phone=${encodeURIComponent(order.phone)}`;
    return `<article class="account-order">
      <div class="account-order__top">
        <div>
          <h3>${escapeHtml(order.id)}</h3>
          <p class="account-order__meta">${escapeHtml(order.city)} · ETA ${escapeHtml(order.eta)} · ${escapeHtml((order.items || []).length)} item(s)</p>
        </div>
        <span class="account-badge">${escapeHtml(status)}</span>
      </div>
      <div class="account-order__actions">
        <a class="btn btn-gold" href="${trackUrl}">Track</a>
        <a class="btn btn-dark" href="https://wa.me/923114711112?text=${encodeURIComponent("Hello - help with order " + order.id)}" target="_blank" rel="noopener noreferrer">WhatsApp</a>
      </div>
    </article>`;
  }

  async function paintDashboard() {
    const user = currentUser();
    if (!user) {
      setAuthVisible(true);
      return;
    }
    setAuthVisible(false);

    const nameEl = document.querySelector("[data-user-name]");
    const emailEl = document.querySelector("[data-user-email]");
    const helloEl = document.querySelector("[data-overview-hello]");
    if (nameEl) nameEl.textContent = `${user.firstName} ${user.lastName}`.trim();
    if (emailEl) emailEl.textContent = user.email;
    if (helloEl) helloEl.textContent = `Signed in as ${user.firstName}. Manage orders, wishlist, and delivery details here.`;

    const orders = await fetchOrdersForUser(user);
    const wish = wishIds();
    const addrs = user.addresses || [];

    const so = document.querySelector("[data-stat-orders]");
    const sw = document.querySelector("[data-stat-wish]");
    const sa = document.querySelector("[data-stat-addr]");
    if (so) so.textContent = String(orders.length);
    if (sw) sw.textContent = String(wish.length);
    if (sa) sa.textContent = String(addrs.length);

    const overviewOrder = document.querySelector("[data-overview-order]");
    if (overviewOrder) {
      overviewOrder.innerHTML = orders.length
        ? renderOrderRow(orders[0])
        : `<div class="account-empty">No orders yet.<br><a class="btn btn-dark" href="/collections/all">Start shopping</a></div>`;
    }

    const ordersList = document.querySelector("[data-orders-list]");
    if (ordersList) {
      ordersList.innerHTML = orders.length
        ? orders.map(renderOrderRow).join("")
        : `<div class="account-empty">No orders linked to this account yet. Track or link an order below.</div>`;
    }

    paintWishlist();
    paintAddresses(user);
    paintProfileForm(user);
    paintPrefs(user);
  }

  function paintWishlist() {
    const grid = document.querySelector("[data-wish-grid]");
    if (!grid) return;
    const map = productMap();
    const ids = wishIds();
    if (!ids.length) {
      grid.innerHTML = `<div class="account-empty">Your wishlist is empty.<br><a class="btn btn-dark" href="/collections/all">Browse the shop</a></div>`;
      return;
    }
    grid.className = "account-wish";
    grid.innerHTML = ids.map((id) => {
      const p = map[id] || { id, title: id, price: "", img: "", url: "/collections/all" };
      return `<article class="account-wish__item">
        <img src="${escapeHtml(p.img || "")}" alt="" loading="lazy">
        <strong>${escapeHtml(p.title || "Product")}</strong>
        <span>${escapeHtml(p.price || "")}</span>
        <a class="btn btn-dark" href="${escapeHtml(p.url || "/collections/all")}">View</a>
      </article>`;
    }).join("");
  }

  function paintAddresses(user) {
    const list = document.querySelector("[data-address-list]");
    if (!list) return;
    const addrs = user.addresses || [];
    if (!addrs.length) {
      list.innerHTML = `<div class="account-empty">No saved addresses yet. Add one below for faster delivery.</div>`;
      return;
    }
    list.innerHTML = addrs.map((a) => `<article class="account-address">
      <div class="account-address__top">
        <h3>${escapeHtml(a.label)}${a.isDefault ? " · Default" : ""}</h3>
      </div>
      <p>${escapeHtml(a.line1)}</p>
      <p>${escapeHtml([a.area, a.city, a.postal].filter(Boolean).join(", "))}</p>
      <p>${escapeHtml(a.phone)}</p>
      <div class="account-address__actions">
        <button type="button" data-edit-address="${escapeHtml(a.id)}">Edit</button>
        <button type="button" data-default-address="${escapeHtml(a.id)}">Make default</button>
        <button type="button" data-remove-address="${escapeHtml(a.id)}">Remove</button>
      </div>
    </article>`).join("");
  }

  function paintProfileForm(user) {
    const form = document.querySelector("[data-profile-form]");
    if (!form) return;
    form.firstName.value = user.firstName || "";
    form.lastName.value = user.lastName || "";
    form.email.value = user.email || "";
    form.phone.value = user.phone || "";
    form.birthday.value = user.birthday || "";
    form.gender.value = user.gender || "";
  }

  function paintPrefs(user) {
    const form = document.querySelector("[data-pref-form]");
    if (!form) return;
    const p = user.preferences || {};
    form.whatsapp.checked = !!p.whatsapp;
    form.email.checked = !!p.email;
    form.sms.checked = !!p.sms;
  }

  function resetAddressForm() {
    const form = document.querySelector("[data-address-form]");
    const title = document.querySelector("[data-address-form-title]");
    const resetBtn = document.querySelector("[data-address-reset]");
    if (!form) return;
    form.reset();
    form.id.value = "";
    if (title) title.textContent = "Add address";
    if (resetBtn) resetBtn.hidden = true;
  }

  /* Auth tabs */
  document.querySelectorAll("[data-auth-tab]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const tab = btn.getAttribute("data-auth-tab");
      document.querySelectorAll("[data-auth-tab]").forEach((b) => {
        const on = b === btn;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      document.querySelectorAll("[data-auth-form]").forEach((f) => {
        f.hidden = f.getAttribute("data-auth-form") !== tab;
      });
    });
  });

  document.querySelector('[data-auth-form="login"]')?.addEventListener("submit", (e) => {
    e.preventDefault();
    const form = e.target;
    const msg = document.querySelector('[data-auth-msg="login"]');
    const email = String(form.email.value || "").trim().toLowerCase();
    const password = String(form.password.value || "");
    const user = readUsers().find((u) => u.email === email && u.password === password);
    if (!user) {
      showMsg(msg, "Invalid email or password.", true);
      return;
    }
    setSession({ id: user.id });
    showMsg(msg, "");
    toast(`Welcome back, ${user.firstName}`);
    paintDashboard();
    switchPanel("overview");
  });

  document.querySelector('[data-auth-form="register"]')?.addEventListener("submit", (e) => {
    e.preventDefault();
    const form = e.target;
    const msg = document.querySelector('[data-auth-msg="register"]');
    const email = String(form.email.value || "").trim().toLowerCase();
    const phone = normalizePhone(form.phone.value);
    if (readUsers().some((u) => u.email === email)) {
      showMsg(msg, "An account with this email already exists.", true);
      return;
    }
    if (phone.length < 10) {
      showMsg(msg, "Enter a valid phone number.", true);
      return;
    }
    const user = {
      id: uid(),
      email,
      password: String(form.password.value || ""),
      firstName: String(form.firstName.value || "").trim(),
      lastName: String(form.lastName.value || "").trim(),
      phone,
      birthday: "",
      gender: "",
      preferences: { whatsapp: true, email: true, sms: false },
      addresses: [],
      linkedOrders: [],
      createdAt: new Date().toISOString()
    };
    saveUser(user);
    setSession({ id: user.id });
    showMsg(msg, "");
    toast("Account created");
    paintDashboard();
    switchPanel("overview");
  });

  document.querySelector("[data-demo-login]")?.addEventListener("click", () => {
    ensureDemoUser();
    const user = readUsers().find((u) => u.email === "sara@example.com");
    if (!user) return;
    setSession({ id: user.id });
    toast("Signed in as Sara");
    paintDashboard();
    switchPanel("overview");
  });

  document.querySelector("[data-logout]")?.addEventListener("click", () => {
    setSession(null);
    toast("Signed out");
    setAuthVisible(true);
  });

  document.querySelectorAll("[data-panel]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const name = btn.getAttribute("data-panel");
      switchPanel(name);
      if (name === "wishlist") paintWishlist();
      if (name === "orders" || name === "overview") paintDashboard();
    });
  });

  document.querySelectorAll("[data-goto]").forEach((btn) => {
    btn.addEventListener("click", () => switchPanel(btn.getAttribute("data-goto")));
  });

  document.querySelector("[data-link-order]")?.addEventListener("submit", async (e) => {
    e.preventDefault();
    const form = e.target;
    const msg = document.querySelector("[data-link-msg]");
    const user = currentUser();
    if (!user) return;
    const order = String(form.order.value || "").trim().toUpperCase();
    const phone = normalizePhone(form.phone.value);
    try {
      const qs = new URLSearchParams({ order, phone });
      const res = await fetch(`/api/track?${qs}`, { cache: "no-store" });
      if (!res.ok) {
        showMsg(msg, "Order not found with that phone.", true);
        return;
      }
      user.linkedOrders = [...new Set([...(user.linkedOrders || []), order])];
      saveUser(user);
      showMsg(msg, "Order linked to your account.", false);
      form.reset();
      await paintDashboard();
      switchPanel("orders");
    } catch (_) {
      showMsg(msg, "Could not link order. Try again.", true);
    }
  });

  document.querySelector("[data-address-form]")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const form = e.target;
    const user = currentUser();
    if (!user) return;
    const id = form.id.value || uid();
    const next = {
      id,
      label: String(form.label.value || "").trim(),
      line1: String(form.line1.value || "").trim(),
      city: String(form.city.value || "").trim(),
      area: String(form.area.value || "").trim(),
      phone: normalizePhone(form.phone.value),
      postal: String(form.postal.value || "").trim(),
      isDefault: !!form.isDefault.checked
    };
    let addresses = [...(user.addresses || [])];
    const idx = addresses.findIndex((a) => a.id === id);
    if (idx >= 0) addresses[idx] = next;
    else addresses.push(next);
    if (next.isDefault) addresses = addresses.map((a) => ({ ...a, isDefault: a.id === id }));
    user.addresses = addresses;
    saveUser(user);
    resetAddressForm();
    paintAddresses(user);
    paintDashboard();
    toast("Address saved");
  });

  document.querySelector("[data-address-reset]")?.addEventListener("click", resetAddressForm);

  document.querySelector("[data-address-list]")?.addEventListener("click", (e) => {
    const user = currentUser();
    if (!user) return;
    const editId = e.target.getAttribute?.("data-edit-address");
    const removeId = e.target.getAttribute?.("data-remove-address");
    const defaultId = e.target.getAttribute?.("data-default-address");

    if (editId) {
      const a = (user.addresses || []).find((x) => x.id === editId);
      const form = document.querySelector("[data-address-form]");
      const title = document.querySelector("[data-address-form-title]");
      const resetBtn = document.querySelector("[data-address-reset]");
      if (!a || !form) return;
      form.id.value = a.id;
      form.label.value = a.label;
      form.line1.value = a.line1;
      form.city.value = a.city;
      form.area.value = a.area || "";
      form.phone.value = a.phone;
      form.postal.value = a.postal || "";
      form.isDefault.checked = !!a.isDefault;
      if (title) title.textContent = "Edit address";
      if (resetBtn) resetBtn.hidden = false;
      form.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    if (removeId) {
      user.addresses = (user.addresses || []).filter((a) => a.id !== removeId);
      saveUser(user);
      paintAddresses(user);
      paintDashboard();
      toast("Address removed");
    }

    if (defaultId) {
      user.addresses = (user.addresses || []).map((a) => ({ ...a, isDefault: a.id === defaultId }));
      saveUser(user);
      paintAddresses(user);
      toast("Default address updated");
    }
  });

  document.querySelector("[data-profile-form]")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const form = e.target;
    const msg = document.querySelector("[data-profile-msg]");
    const user = currentUser();
    if (!user) return;
    const email = String(form.email.value || "").trim().toLowerCase();
    if (readUsers().some((u) => u.email === email && u.id !== user.id)) {
      showMsg(msg, "Email already in use.", true);
      return;
    }
    user.firstName = String(form.firstName.value || "").trim();
    user.lastName = String(form.lastName.value || "").trim();
    user.email = email;
    user.phone = normalizePhone(form.phone.value);
    user.birthday = form.birthday.value || "";
    user.gender = form.gender.value || "";
    saveUser(user);
    showMsg(msg, "Profile saved.", false);
    paintDashboard();
    toast("Profile updated");
  });

  document.querySelector("[data-pref-form]")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const form = e.target;
    const msg = document.querySelector("[data-pref-msg]");
    const user = currentUser();
    if (!user) return;
    user.preferences = {
      whatsapp: !!form.whatsapp.checked,
      email: !!form.email.checked,
      sms: !!form.sms.checked
    };
    saveUser(user);
    showMsg(msg, "Preferences saved.", false);
    toast("Preferences updated");
  });

  document.querySelector("[data-security-form]")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const form = e.target;
    const msg = document.querySelector("[data-security-msg]");
    const user = currentUser();
    if (!user) return;
    if (form.current.value !== user.password) {
      showMsg(msg, "Current password is incorrect.", true);
      return;
    }
    if (form.next.value !== form.confirm.value) {
      showMsg(msg, "New passwords do not match.", true);
      return;
    }
    if (String(form.next.value).length < 6) {
      showMsg(msg, "Password must be at least 6 characters.", true);
      return;
    }
    user.password = form.next.value;
    saveUser(user);
    form.reset();
    showMsg(msg, "Password updated.", false);
    toast("Password changed");
  });

  /* boot */
  ensureDemoUser();
  const tab = new URLSearchParams(window.location.search).get("tab") || "overview";
  if (currentUser()) {
    paintDashboard().then(() => switchPanel(tab));
  } else {
    setAuthVisible(true);
    if (location.pathname.includes("login") || new URLSearchParams(location.search).get("mode") === "register") {
      document.querySelector('[data-auth-tab="register"]')?.click();
    }
  }

  // Keep wishlist counts in sync if user returns from shop
  window.addEventListener("focus", () => {
    if (currentUser()) {
      paintWishlist();
      const sw = document.querySelector("[data-stat-wish]");
      if (sw) sw.textContent = String(wishIds().length);
    }
  });
})();
